import { GuestConversationDetails } from "src/components/GuestInbox/GuestConversations/GuestConversationDetails"
import { TGuest } from "src/data/guests/types/guestTypes"
import { MDialog } from "src/ui/Dialog/MDialog"

export function GuestConversationDetailsDialog({
  onClose,
  guest,
}: {
  onClose: () => void
  guest: TGuest
}) {
  return (
    <MDialog open={true} onClose={onClose} title="Details">
      <GuestConversationDetails guest={guest} />
    </MDialog>
  )
}
